var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-dialog"},[_c('div',{staticClass:"modal-content"},[_vm._v(" "+_vm._s(_vm.error)+" "),_c('app-button',{attrs:{"name":"閉じる"},on:{"click":_vm.close}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }